import { parse } from 'qs';

import { localStorage } from '@sorare/core/src/lib/storage/localStorage';
import { sessionStorage } from '@sorare/core/src/lib/storage/sessionStorage';

import {
  queryParamsToLocalStorageKeys,
  queryParamsToSessionStorageKeys,
} from './storage';

// eslint-disable-next-line no-restricted-properties
const searchParams = parse(window.location.search, { ignoreQueryPrefix: true });

const LOCAL_STORAGE_KEYS = Object.keys(
  queryParamsToLocalStorageKeys
) as (keyof typeof queryParamsToLocalStorageKeys)[];
// if any UTM params are present, clear former ones from local storage first to avoid merging them together
if (LOCAL_STORAGE_KEYS.some(key => searchParams[key])) {
  LOCAL_STORAGE_KEYS.forEach(key => localStorage.removeItem(key));
}
Object.entries(queryParamsToLocalStorageKeys).forEach(([qsKey, lskey]) => {
  const value = searchParams[qsKey];
  if (value) {
    localStorage.setItem(
      lskey,
      typeof value === 'string' ? value : JSON.stringify(value)
    );
  }
});
Object.entries(queryParamsToSessionStorageKeys).forEach(([qsKey, sskey]) => {
  const value = searchParams[qsKey];
  if (value) {
    sessionStorage.setItem(
      sskey,
      typeof value === 'string' ? value : JSON.stringify(value)
    );
  }
});
